<template>
  <div class="min-h-full">
    <PageHeader title="Attribution" :breadcrumbs="[{ label: 'Beta' }]" />
    <div class="p-6">
      <Attribution_Flow />
    </div>
  </div>
</template>

<script>
import Attribution_Flow from '@/components/Portfolio_Management/Attribution_Flow.vue';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';

export default {
  name: 'AttributionTab',
  components: {
    Attribution_Flow,
    PageHeader,
  },
}
</script>
